import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../base-modal/base-modal.component";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {ChangelogItem, DialogData} from "./types/changelog-modal.types";
import {MatButton} from "@angular/material/button";
import {CommonModule} from "@angular/common";
import {changelogModalName} from "./configs/changelog-modal-config";

@Component({
  selector: 'app-changelog-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    MatButton,
    CommonModule
  ],
  templateUrl: './changelog-modal.component.html',
  styleUrls: [
    './changelog-modal.component.scss',
    '../base-modal/base-modal.component.scss'
  ]
})
export class ChangelogModalComponent extends BaseModalComponent {
  public dialogData = inject<DialogData>(MAT_DIALOG_DATA);

  protected readonly Object = Object;
  public changelogs: Record<string, ChangelogItem> | null = null;

  public override ngOnInit(): void {
    this.modalStatesService.openModal(changelogModalName);
    this.initChangelog();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(changelogModalName);
  }

  private initChangelog() {
    this.changelogs = {
      back: { title: 'Журнал изменений бэк', content: this.dialogData.changelogBack ?? '' },
      front: { title: 'Журнал изменений фронт', content: this.dialogData.changelogFront ?? '' }
    };
  }
}
